import { Icon } from 'semantic-ui-react';
import React from 'react';

const alarmsConfigShape = new Map();

alarmsConfigShape.set('machineShortName', {
  header: {
    title: 'common.machine',
    doubleRow: true,
  },
});

alarmsConfigShape.set('hall', {
  header: {
    title: 'common.hall',
    doubleRow: true,
  },
});

alarmsConfigShape.set('yellowConfig', {
  header: {
    title: 'alarmsConfig.machine-yellow',
    colSpan: '3',
    secondRowRenderFn: [
      () => [1].map(num => <Icon key={num} name="attention" color="yellow" />),
      () => [1, 2].map(num => <Icon key={num} name="attention" color="yellow" />),
      () => [1, 2, 3].map(num => <Icon key={num} name="attention" color="yellow" />),
    ],
  },
  cell: {
    renderFn: cellsInfo => cellsInfo.map(({ value }) => <span>{`${value}m`}</span>),
  },
});

alarmsConfigShape.set('redConfig', {
  header: {
    title: 'alarmsConfig.machine-red',
    colSpan: '3',
    secondRowRenderFn: [
      () => [1].map(num => <Icon key={num} name="attention" color="red" />),
      () => [1, 2].map(num => <Icon key={num} name="attention" color="red" />),
      () => [1, 2, 3].map(num => <Icon key={num} name="attention" color="red" />),
    ],
  },
  cell: {
    renderFn: cellsInfo => cellsInfo.map(({ value }) => <span>{`${value}m`}</span>),
  },
});

export default alarmsConfigShape;



// WEBPACK FOOTER //
// ./src/shapes/alarmsConfigShape.js